import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ApacheHttpIcon = props => (
  <Icon viewBox="0 0 32 32" w="full" h="full" color="inherit" {...props}>
    <defs>
      <linearGradient
        id="apache-a"
        x1="-5602.682"
        y1="768.541"
        x2="-5598.727"
        y2="763.917"
        gradientTransform="matrix(0.423, -0.906, -0.906, -0.423, 3082.853, -4748.551)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f69923" />
        <stop offset="0.312" stop-color="#f79a23" />
        <stop offset="0.838" stop-color="#e97826" />
      </linearGradient>
      <linearGradient
        id="apache-b"
        x1="-5631.952"
        y1="769.052"
        x2="-5603.737"
        y2="769.052"
        gradientTransform="matrix(0.423, -0.906, -0.906, -0.423, 3082.853, -4748.551)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.323" stop-color="#9e2064" />
        <stop offset="0.63" stop-color="#c92037" />
        <stop offset="0.751" stop-color="#cd2335" />
        <stop offset="1" stop-color="#e97826" />
      </linearGradient>
      <linearGradient
        id="apache-c"
        x1="-5628.546"
        y1="766.221"
        x2="-5611.733"
        y2="766.221"
        gradientTransform="matrix(0.423, -0.906, -0.906, -0.423, 3082.853, -4748.551)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#282662" />
        <stop offset="0.095" stop-color="#662e8d" />
        <stop offset="0.788" stop-color="#9f2064" />
        <stop offset="0.949" stop-color="#cd2032" />
      </linearGradient>
      <linearGradient
        id="apache-d"
        x1="-5630.367"
        y1="769.316"
        x2="-5602.152"
        y2="769.316"
        xlinkHref="#apache-b"
      />
      <linearGradient
        id="apache-e"
        x1="-5628.31"
        y1="768.933"
        x2="-5613.482"
        y2="768.933"
        xlinkHref="#apache-c"
      />
      <linearGradient
        id="apache-f"
        x1="-5630.367"
        y1="766.394"
        x2="-5602.152"
        y2="766.394"
        xlinkHref="#apache-b"
      />
      <linearGradient
        id="apache-g"
        x1="-5632.118"
        y1="766.539"
        x2="-5603.902"
        y2="766.539"
        xlinkHref="#apache-b"
      />
      <linearGradient
        id="apache-h"
        x1="-5630.367"
        y1="765.526"
        x2="-5602.152"
        y2="765.526"
        xlinkHref="#apache-b"
      />
      <linearGradient
        id="apache-i"
        x1="-5630.367"
        y1="765.625"
        x2="-5602.152"
        y2="765.625"
        xlinkHref="#apache-b"
      />
      <linearGradient
        id="apache-j"
        x1="-5614.516"
        y1="765.645"
        x2="-5608.28"
        y2="765.645"
        xlinkHref="#apache-b"
      />
    </defs>
    <title>file_type_apache</title>
    <path
      d="M19.993,2.133a10.267,10.267,0,0,0-2.04,2.056l.8,1.51a19.733,19.733,0,0,1,1.708-2.144c.044-.049.068-.072.068-.072l-.068.072a17.865,17.865,0,0,0-1.6,2.174,30.1,30.1,0,0,0,3.111-.385,3.288,3.288,0,0,0-.3-2.5S20.9,1.6,19.993,2.133Z"
      fill="url(#apache-a)"
    />
    <path d="M18.638,10.749l.018,0-.115.013-.021.009Z" fill="none" />
    <path
      d="M17.821,13.455c-.066.015-.132.026-.2.036C17.689,13.481,17.756,13.469,17.821,13.455Z"
      fill="none"
    />
    <path
      d="M12.27,19.524c.009-.023.017-.045.025-.068q.264-.7.523-1.357.291-.741.575-1.436.3-.733.59-1.418.305-.718.6-1.384.24-.542.474-1.049.078-.169.155-.335.153-.329.3-.645.138-.291.274-.57c.03-.062.06-.123.09-.185l.015-.03-.1.011-.078-.154c-.007.015-.015.03-.023.045q-.211.418-.417.845-.119.246-.238.495-.328.689-.645,1.389T13.766,15.1q-.3.7-.594,1.4t-.567,1.387q-.289.72-.562,1.426-.062.159-.123.318-.219.569-.426,1.124l.123.243.11-.012.012-.033Q12.008,20.216,12.27,19.524Z"
      fill="none"
    />
    <path d="M17.57,13.5Z" fill="none" />
    <path
      d="M17.305,14.818l-.315.055h0l.161-.025C17.2,14.839,17.253,14.829,17.305,14.818Z"
      fill="#be202e"
    />
    <path
      d="M17.305,14.818l-.315.055h0l.161-.025C17.2,14.839,17.253,14.829,17.305,14.818Z"
      fill="#be202e"
      opacity={0.3499999940395355} //;isolation:isolate"
    />
    <path
      d="M17.573,13.5h0l.05-.007c.068-.01.135-.022.2-.036l-.248.042Z"
      fill="#be202e"
    />
    <path
      d="M17.573,13.5h0l.05-.007c.068-.01.135-.022.2-.036l-.248.042Z"
      fill="#be202e"
      opacity={0.3499999940395355} //;isolation:isolate"
    />
    <path
      d="M16.394,9.6q.365-.682.739-1.332.388-.674.784-1.305l.046-.075q.392-.62.79-1.191l-.8-1.51-.182.225c-.231.288-.47.6-.716.925-.277.37-.562.764-.851,1.179-.267.383-.538.784-.809,1.2-.231.353-.462.717-.692,1.09l-.026.042L15.718,10.9Q16.052,10.244,16.394,9.6Z"
      fill="url(#apache-b)"
    />
    <path
      d="M11.651,21.192q-.207.568-.415,1.159l-.006.017-.059.167c-.093.266-.175.5-.361,1.049a2.107,2.107,0,0,1,.786.926,1.68,1.68,0,0,0-.544-1.154,3.621,3.621,0,0,0,3.489-1.42,2.791,2.791,0,0,0,.165-.313,1.451,1.451,0,0,1-1.4.513l0,0,0,0a4.059,4.059,0,0,0,2.046-1.672c.111-.178.218-.372.328-.587a3.3,3.3,0,0,1-3.109,1.01l-.842.092C11.7,21.05,11.677,21.121,11.651,21.192Z"
      fill="url(#apache-c)"
    />
    <path
      d="M12.044,19.306q.273-.706.562-1.426.276-.69.567-1.387t.594-1.4q.308-.711.629-1.419t.645-1.389q.118-.248.238-.495.207-.426.417-.845c.007-.015.015-.03.023-.045L14.677,8.847l-.051.083c-.242.4-.484.8-.721,1.216s-.475.844-.7,1.276q-.291.547-.568,1.1l-.11.225c-.227.467-.432.918-.617,1.352q-.315.737-.556,1.406c-.107.293-.2.576-.292.847-.073.232-.142.464-.208.7q-.234.818-.4,1.631L11.5,20.748q.208-.554.426-1.124Z"
      fill="url(#apache-d)"
    />
    <path
      d="M10.435,18.755a16.07,16.07,0,0,0-.272,1.974c0,.023,0,.046-.005.069a4.15,4.15,0,0,0-1.2-1.029,5.825,5.825,0,0,1,1.172,2.693,2.642,2.642,0,0,1-1.325-.226,2.662,2.662,0,0,0,1.13.686,3.247,3.247,0,0,0-1.571.783,3.359,3.359,0,0,1,1.861-.342C9.51,25.389,8.793,27.626,8.076,30a.625.625,0,0,0,.425-.413c.128-.43.976-3.251,2.306-6.959l.115-.318.032-.089q.211-.583.437-1.19l.1-.277,0-.005L10.45,18.684C10.445,18.707,10.439,18.731,10.435,18.755Z"
      fill="url(#apache-e)"
    />
    <path
      d="M15.88,11.078l-.09.185q-.135.279-.274.57-.15.315-.3.645c-.052.111-.1.222-.155.335q-.234.508-.474,1.049-.3.666-.6,1.384-.291.685-.59,1.418-.284.7-.575,1.436-.259.661-.523,1.357c-.009.023-.017.045-.025.068q-.262.693-.529,1.422l-.012.033.842-.092-.05-.009a6,6,0,0,0,3.21-1.807,7.984,7.984,0,0,0,1.1-1.524,13.139,13.139,0,0,0,.706-1.467c.195-.472.382-.982.562-1.536a3.053,3.053,0,0,1-.788.274c-.051.011-.1.021-.156.03s-.107.018-.161.025h0a3.668,3.668,0,0,0,1.962-1.913,3.344,3.344,0,0,1-1.13.495c-.066.015-.132.026-.2.036l-.05.007h0a3.821,3.821,0,0,0,.839-.469c.051-.038.1-.078.148-.12.073-.063.142-.129.208-.2.042-.044.083-.09.123-.138a3.27,3.27,0,0,0,.263-.362c.025-.04.05-.08.074-.122.031-.06.061-.119.09-.178.131-.264.236-.5.319-.706.042-.1.078-.2.109-.288.013-.035.025-.07.036-.1.033-.1.06-.187.081-.265a2.605,2.605,0,0,0,.062-.275h0a1.01,1.01,0,0,1-.109.075,3.965,3.965,0,0,1-1.162.4l.773-.085-.773.085-.018,0-.119.019.021-.009-2.645.29Z"
      fill="url(#apache-f)"
    />
    <path
      d="M18.858,5.73c-.235.361-.492.771-.768,1.236l-.044.074q-.358.6-.759,1.327-.346.626-.719,1.347-.326.629-.672,1.336l2.645-.29A3.216,3.216,0,0,0,19.99,9.62c.089-.128.178-.262.267-.4.272-.424.538-.891.776-1.355a14.074,14.074,0,0,0,.588-1.294,6.8,6.8,0,0,0,.233-.7c.048-.184.086-.358.115-.524A30.152,30.152,0,0,1,18.858,5.73Z"
      fill="url(#apache-g)"
    />
    <path
      d="M17.149,14.848c-.053.009-.107.018-.161.025h0C17.042,14.866,17.1,14.857,17.149,14.848Z"
      fill="#be202e"
    />
    <path
      d="M17.149,14.848c-.053.009-.107.018-.161.025h0C17.042,14.866,17.1,14.857,17.149,14.848Z"
      fill="#be202e"
      opacity={0.3499999940395355} //;isolation:isolate"
    />
    <path
      d="M17.149,14.848c-.053.009-.107.018-.161.025h0C17.042,14.866,17.1,14.857,17.149,14.848Z"
      fill="url(#apache-h)"
    />
    <path d="M17.57,13.5l.05-.007-.05.007Z" fill="#be202e" />
    <path
      d="M17.57,13.5l.05-.007-.05.007Z"
      fill="#be202e" //isolation:isolate"
      opacity={0.3499999940395355}
    />
    <path d="M17.57,13.5l.05-.007-.05.007Z" fill="url(#apache-i)" />
    <path d="M17.572,13.5h0Z" fill="#be202e" />
    <path
      d="M17.572,13.5h0Z"
      fill="#be202e"
      opacity={0.3499999940395355} //;isolation:isolate"
    />
    <path d="M17.572,13.5h0Z" fill="url(#apache-j)" />
  </Icon>
);
